import { combineReducers, configureStore } from '@reduxjs/toolkit';

import Constants from 'utils/Constants';
import { eraseCookie } from 'utils/cookies';
import map from './reducers/map';
import snackbar from './reducers/snackbar';
import user from './reducers/user';
import publicUser from './reducers/publicUser';

const reducers = { map, snackbar, user, publicUser };
const rootReducer = combineReducers(reducers);

const resettableRootReducer = (state, action) => {
  if (action.type === Constants.RESET_APP) {
    eraseCookie(Constants.ACCESS_TOKEN);
    eraseCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: resettableRootReducer,
});
